import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'engage',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../engagement/app/src/engagement.routes').then((t) => t.ENGAGEMENT_ROUTES),
            canActivate: [clientConfigAppGuard],
            data: { product: ClientConfigProductName.ENGAGE },
        },
    ],
};

export default routes;
